import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Input, FormGroup, Label, Form, Row, Col, Card, CardBody, InputGroup, InputGroupText } from "reactstrap";
import { useDispatch } from "react-redux";
import { loadingTrue, loadingFalse } from "../../Reducer/loaderSlice";
import Handler from "../../Helpers/Handler";
import Swal from "sweetalert2";
import { toast } from "react-toastify";

const EditExpense = () => {
    const { id } = useParams(); 
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Backend Input-ku yetha mari states
    const [formData, setFormData] = useState({
        expense_id: id,
        type: "",
        amount: "",
        description: "",
        date: ""
    });

    const [staffInfo, setStaffInfo] = useState(null); // Staff details display panna mattum
    const [errors, setErrors] = useState({});

    // 1. Fetch Existing Data
    const getExpenseDetails = async () => {
        dispatch(loadingTrue());
        try {
            const res = await Handler({ 
                method: "GET", 
                url: `/expense/view.php?id=${id}` // Unga 2nd PHP script path
            });

            if (res?.success) {
                const d = res.data.expense;
                setFormData({
                    expense_id: d.id,
                    type: d.type || "",
                    amount: d.amount || "",
                    description: d.description || "",
                    date: d.created_at ? d.created_at.split(' ')[0] : "" // Y-m-d format-ku edukrom
                });
                setStaffInfo(res.data.staff);
            } else {
                toast.error(res?.message || "Expense not found");
                navigate("/expenses");
            }
        } catch (err) {
            toast.error("Error fetching data");
        } finally {
            dispatch(loadingFalse());
        }
    };

    useEffect(() => {
        if (id) getExpenseDetails();
    }, [id]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        if (errors[e.target.name]) {
            setErrors({ ...errors, [e.target.name]: "" });
        }
    };

    // 2. Submit Update
    const handleSubmit = async (e) => {
        e.preventDefault();
        dispatch(loadingTrue());
        setErrors({});

        try {
            const res = await Handler({
                method: "POST", // Unga PHP PUT/POST renduமே support pannum
                url: "/expense/admin_update.php", 
                data: formData
            });

            if (res?.success) {
                Swal.fire("Updated!", "Expense updated successfully", "success");
                navigate("/expenses");
            } else {
                if (res?.errors) {
                    setErrors(res.errors); // Backend validation errors (min 3 chars etc.)
                } else {
                    toast.error(res?.message || "Update failed");
                }
            }
        } catch (err) {
            Swal.fire("Error", "Server error occurred", "error");
        } finally {
            dispatch(loadingFalse());
        }
    };

    return (
        <div className="page-container p-1">
            <div className="page-header mb-4">
                <h6 className="text-muted">Finance &gt; Expenses &gt; Edit</h6>
                <div className="d-flex justify-content-between align-items-center">
                    <div>
                        <h3 className="fw-bold">Edit Expense Entry</h3>
                        <p className="text-muted">Modify transaction details for ID: #{id}</p>
                    </div>
                    <Button color="secondary" outline onClick={() => navigate(-1)}>
                        <i className="bx bx-arrow-back"></i> Back
                    </Button>
                </div>
            </div>

            <Row>
                <Col lg={8}>
                    <Card className="border-0 shadow-sm" style={{ borderRadius: '15px' }}>
                        <CardBody className="p-4">
                            <Form onSubmit={handleSubmit}>
                                <Row>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Expense Type *</Label>
                                            <Input
                                                type="text"
                                                name="type"
                                                placeholder="e.g. Transport, Salary"
                                                className={errors.type ? "is-invalid" : ""}
                                                value={formData.type}
                                                onChange={handleChange}
                                            />
                                            {errors.type && <div className="invalid-feedback">{errors.type}</div>}
                                        </FormGroup>
                                    </Col>
                                    <Col md={6}>
                                        <FormGroup>
                                            <Label>Date</Label>
                                            <Input
                                                type="date"
                                                name="date"
                                                className={errors.date ? "is-invalid" : ""}
                                                value={formData.date}
                                                onChange={handleChange}
                                            />
                                            {errors.date && <div className="invalid-feedback">{errors.date}</div>}
                                        </FormGroup>
                                    </Col>
                                </Row>

                                <FormGroup className="mt-3">
                                    <Label>Amount *</Label>
                                    <InputGroup>
                                        <InputGroupText>₹</InputGroupText>
                                        <Input
                                            type="number"
                                            name="amount"
                                            placeholder="0.00"
                                            className={errors.amount ? "is-invalid" : ""}
                                            value={formData.amount}
                                            onChange={handleChange}
                                        />
                                        {errors.amount && <div className="invalid-feedback">{errors.amount}</div>}
                                    </InputGroup>
                                </FormGroup>

                                <FormGroup className="mt-3">
                                    <Label>Description / Remarks *</Label>
                                    <Input
                                        type="textarea"
                                        name="description"
                                        rows="4"
                                        placeholder="Enter update reason or details..."
                                        className={errors.description ? "is-invalid" : ""}
                                        value={formData.description}
                                        onChange={handleChange}
                                    />
                                    {errors.description && <div className="invalid-feedback">{errors.description}</div>}
                                </FormGroup>

                                <div className="mt-4 pt-3 border-top d-flex justify-content-end">
                                    <Button type="submit" className="add-btn px-5" style={{backgroundColor: '#2e4a3d', border: 'none'}}>
                                        <i className="bx bx-save me-1"></i> Update Changes
                                    </Button>
                                </div>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>

                <Col lg={4}>
                    {/* Staff Context Card */}
                    <Card className="border-0 shadow-sm mb-3" style={{ borderRadius: '15px' }}>
                        <CardBody className="p-4">
                            <h6 className="fw-bold mb-3">Created By</h6>
                            {staffInfo ? (
                                <div className="d-flex align-items-center">
                                    <div className="avatar me-3 bg-light-primary p-2 rounded">
                                        <i className="bx bx-user fs-3"></i>
                                    </div>
                                    <div>
                                        <p className="mb-0 fw-bold">{staffInfo.name}</p>
                                        <small className="text-muted">{staffInfo.phone}</small>
                                    </div>
                                </div>
                            ) : (
                                <p className="text-success fw-bold mb-0">
                                    <i className="bx bxs-badge-check me-1"></i> Admin Entry
                                </p>
                            )}
                            <hr />
                            <div className="small text-muted">
                                <b>Note:</b> Backend validation requires description to be at least 3 characters.
                            </div>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default EditExpense;